// External Components
import React from 'react'
import {
  BrowserRouter,
  Route,
  Switch
} from 'react-router-dom'
// import { combineReducers, createStore } from 'redux'
// import { Provider, connect } from 'react-redux'
// import { firstNamedReducer } from './reducers/PortfolioReducer'

// Local Components
import Projects from './pages/Projects/Projects'
import AnalyticsTracker from './components/Analytics/AnalyticsTracker'

// Global Page Styles
import './Reset.css'
import './App.css'

// ReactGA.initialize('UA-78680-13');
// ReactGA.pageview(window.location.pathname + window.location.search);

// const rootReducer = combineReducers({
//   firstNamedReducer
// })

// const store = createStore(rootReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())

// const Container = () =>
//   <Provider>
//     <App />
//   </Provider>

const App = ({ projects }) =>
  <BrowserRouter>
    <Switch>
      <Route path='/tech/:tech' component={AnalyticsTracker(Projects)} />
      <Route path='/:projectId?' component={AnalyticsTracker(Projects)} />
    </Switch>
  </BrowserRouter>

// const mapStateToProps = (state) => ({
//   projects: state.projects
// })

// connect(state => state)(App)
export default App



// WEBPACK FOOTER //
// ./src/App.js